export default function(event, el) {
  var rect = el.getBoundingClientRect();
  return [
    event.clientX - rect.left - (el.clientLeft || 0),
    event.clientY - rect.top - (el.clientTop || 0)
  ];
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vega-scenegraph/src/util/point.js
// module id = 449
// module chunks = 0